import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-left-white.svg'
import _imports_1 from '@/app/ui/assets/svg/cash.svg'
import _imports_2 from '@/app/ui/assets/ocbc-illustration/ocbc-notification.svg'
import _imports_3 from '@/app/ui/assets/ocbc-illustration/ocbc-illustration-1.svg'
import _imports_4 from '@/app/ui/assets/images/progressive-commission/bonus-komisi-illustration.png'
import _imports_5 from '@/app/ui/assets/svg/Bonus-Komisi-Icon-Collapse.svg'
import _imports_6 from '@/app/ui/assets/svg/cod-red.svg'
import _imports_7 from '@/app/ui/assets/svg/chevron-right.svg'
import _imports_8 from '@/app/ui/assets/svg/no-notif.svg'


const _hoisted_1 = {
  key: 1,
  class: "flex flex-row justify-center items-center text-center py-3 px-6 logo-container"
}
const _hoisted_2 = {
  key: 2,
  class: "flex flex-col relative w-full"
}
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row gap-x-1.5 absolute bottom-0 left-17"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "bg-red-lp-1700 px-1 py-0.5 text-white text-8px rounded-sm" }, "Internal", -1)
const _hoisted_5 = {
  class: "px-3 text-gray-lp-800 font-medium mt-4 whitespace-nowrap",
  style: {"font-size":"10px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Versi sebelumnya. ")
const _hoisted_7 = {
  key: 0,
  class: "flex-none pt-4 saldo-box"
}
const _hoisted_8 = { class: "flex w-full justify-between" }
const _hoisted_9 = { class: "text-gray-lp-500" }
const _hoisted_10 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "relative"
}
const _hoisted_13 = {
  key: 0,
  class: "text-gray-lp-500 text-12px font-normal"
}
const _hoisted_14 = { class: "flex flex-no-wrap justify-center" }
const _hoisted_15 = {
  key: 0,
  class: "text-white py-3 px-4"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "text-12px italic" }, " Limit Pinjaman ", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-16px font-semibold whitespace-no-wrap" }, " Rp 200.000.000 ", -1)
const _hoisted_18 = {
  key: 1,
  class: "text-right flex pt-1"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  class: "self-start",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  class: "self-end",
  src: _imports_3,
  alt: "ocbc"
}, null, -1)
const _hoisted_21 = {
  key: 2,
  class: "self-center py-2"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_23 = {
  key: 1,
  class: "mt-4 mx-2 border-gray-lp-400"
}
const _hoisted_24 = {
  key: 0,
  class: "text-white py-3 px-2 w-11/12"
}
const _hoisted_25 = { class: "text-12px font-bold text-yellow-lp-1000 mb-1" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "text-10px" }, " Tambah pendapatan ", -1)
const _hoisted_28 = { class: "text-10px font-bold whitespace-no-wrap flex flex-row" }
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "font-normal px-1" }, "untuk", -1)
const _hoisted_30 = {
  key: 1,
  class: "text-10px"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Selamat! ")
const _hoisted_32 = /*#__PURE__*/_createVNode("p", null, "Anda telah mendapat bonus", -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Tetap semangat dalam bekerja! ")
const _hoisted_34 = {
  key: 1,
  class: "text-right flex pt-1"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("img", {
  class: "self-end",
  src: _imports_4,
  alt: "bonus komisi"
}, null, -1)
const _hoisted_36 = {
  key: 2,
  class: "self-center"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("hr", { class: "mt-4 mx-2 border-gray-lp-400" }, null, -1)
const _hoisted_39 = {
  key: 1,
  id: "key-cod-income",
  class: "flex-none items-start pt-4"
}
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-500" }, "Penghasilan COD", -1)
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "text-black-lp-300 text-12px xxl:text-16px font-semibold" }
const _hoisted_43 = /*#__PURE__*/_createVNode("hr", { class: "mt-4 mx-2 border-gray-lp-400" }, null, -1)
const _hoisted_44 = { class: "grow h-full overflow-auto" }
const _hoisted_45 = { class: "absolute text-green-lp-100 right-0 top-0" }
const _hoisted_46 = {
  key: 1,
  class: "flex flex-row items-center relative"
}
const _hoisted_47 = { class: "absolute text-green-lp-100 right-0 top-0" }
const _hoisted_48 = { class: "flex flex-row items-center gap-x-2" }
const _hoisted_49 = { class: "flex flex-row items-center justify-center" }
const _hoisted_50 = { class: "flex flex-col w-full" }
const _hoisted_51 = { class: "text-gray-lp-300 w-full flex flex-col" }
const _hoisted_52 = { class: "flex flex-row items-center" }
const _hoisted_53 = { class: "py-2 bg-red-lp-200 font-bold text-white px-6" }
const _hoisted_54 = { class: "px-6 py-2 text-gray-lp-300 w-full flex flex-col" }
const _hoisted_55 = { class: "flex flex-row items-center" }
const _hoisted_56 = { class: "px-4 py-2 text-black-lp-300 logout-box" }
const _hoisted_57 = { class: "flex flex-row items-center relative cursor-pointer" }
const _hoisted_58 = {
  class: "absolute text-green-lp-100 right-0 top-0",
  style: {"top":"2px","right":"1px"}
}
const _hoisted_59 = {
  id: "tooltip-notification",
  class: "bg-white rounded-md relative z-40 flex flex-row items-end w-350px xxl:w-500px",
  style: {"box-shadow":"0px 0px 3px 1px #b1b1b1"}
}
const _hoisted_60 = { class: "text-black-lp-300 flex flex-col w-full" }
const _hoisted_61 = { class: "flex flex-row px-6 py-2 xxl:py-3 items-center justify-between border-b border-gray-lp-400" }
const _hoisted_62 = { class: "flex flex-row items-center" }
const _hoisted_63 = { class: "text-black-lp-200 text-12px xxl:text-16px font-semibold mr-2" }
const _hoisted_64 = {
  key: 0,
  class: "w-full h-500px bg-white justify-center items-center flex flex-col mx-auto py-20 text-12px xxl:text-14px overflow-hidden rounded-b-md"
}
const _hoisted_65 = { key: 1 }
const _hoisted_66 = {
  key: 0,
  class: "w-full h-500px bg-white justify-center items-center flex flex-col mx-auto py-20 text-12px xxl:text-14px overflow-hidden rounded-b-md"
}
const _hoisted_67 = {
  key: 1,
  class: "w-full h-500px bg-white justify-center items-center flex flex-col mx-auto py-20 text-12px xxl:text-14px overflow-hidden rounded-b-md"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("img", {
  src: _imports_8,
  class: "w-32 mx-auto",
  alt: ""
}, null, -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px text-gray-lp-800 font-normal py-2 px-10 text-center" }, " Belum ada pesan yang dapat ditampilkan ", -1)
const _hoisted_70 = {
  key: 2,
  class: "overflow-auto h-500px xxl:h-800px"
}
const _hoisted_71 = { class: "px-6 py-4 text-12px text-gray-lp-500" }
const _hoisted_72 = { class: "w-6 mr-2" }
const _hoisted_73 = { class: "flex flex-col text-12px w-full" }
const _hoisted_74 = { class: "flex flex-row justify-between" }
const _hoisted_75 = { class: "text-gray-lp-300 mr-6" }
const _hoisted_76 = { class: "font-semibold" }
const _hoisted_77 = { class: "text-gray-lp-500 whitespace-no-wrap" }
const _hoisted_78 = { class: "flex flex-row items-center" }
const _hoisted_79 = { class: "w-full flex flex-row items-start" }
const _hoisted_80 = { class: "flex" }
const _hoisted_81 = { class: "flex flex-col text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_SidebarIcon = _resolveComponent("SidebarIcon")!
  const _component_Circle = _resolveComponent("Circle")!
  const _component_Pill = _resolveComponent("Pill")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_MenuRating = _resolveComponent("MenuRating")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Logout = _resolveComponent("Logout")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_OcbcPopupModal = _resolveComponent("OcbcPopupModal")!
  const _component_ModalFeedbackReview = _resolveComponent("ModalFeedbackReview")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", {
      style: {"box-shadow":"0 0 15px 0 #e0e0e0"},
      class: 
      `${
        _ctx.isCollapse
          ? 'hidden w-17'
          : 'absolute z-30 top-0 left-0 flex w-60 xxl:w-64'
      }
       bg-gray-lp-700 h-screen flex-col text-12px xxl:text-14px ${!this.isMobileMode ? 'md:flex md:relative' : ''}`
    
    }, [
      _createVNode("div", {
        class: ["flex flex-row items-center border-b border-gray-lp-400 relative", {
        'px-2 py-2 mt-2 justify-center': _ctx.isCollapse,
        'px-4 py-4': !_ctx.isCollapse
      }]
      }, [
        (_ctx.isCollapse)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: 
          require(`@/app/ui/assets/svg/logo${
            _ctx.isSenderAccount ? '-lion' : ''
          }.svg`)
        ,
              style: {"width":"27px"},
              alt: "logo"
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        (_ctx.isSenderAccount && !_ctx.isCollapse && _ctx.logoSource)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("img", {
                src: require(`@/app/ui/assets/svg/logo-sender.svg`),
                class: "w-auto h-6",
                alt: "logo"
              }, null, 8, ["src"])
            ]))
          : (_ctx.dataProfile.account_type && !_ctx.isCollapse && _ctx.logoSource)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode("img", {
                  src: require(`@/app/ui/assets/svg/logo-${_ctx.logoSource}.svg`),
                  class: "mr-2 w-40",
                  alt: "logo"
                }, null, 8, ["src"]),
                (_ctx.dataProfile.account_type === 'internal')
                  ? (_openBlock(), _createBlock("div", _hoisted_3, [
                      _hoisted_4,
                      (_ctx.accountDivisionName)
                        ? (_openBlock(), _createBlock("span", {
                            key: 0,
                            class: ["bg-gray-lp-1400 px-1 py-0.5 font-semibold text-gray-lp-800 rounded-sm", `${ _ctx.getDivisionName.length > 20 ? 'text-7px' : 'text-8px' }`]
                          }, _toDisplayString(_ctx.getDivisionName), 3))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
        _createVNode("button", {
          class: "bg-red-lp-100 absolute z-10 rounded-full -bottom-3 -right-3.5 p-1.5 xxl:p-2 items-center focus:outline-none expand",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCollapse && _ctx.openCollapse(...args)))
        }, [
          _createVNode("img", {
            src: _imports_0,
            class: ["duration-300 w-3", { collapse: _ctx.isCollapse }],
            alt: "left"
          }, null, 2)
        ])
      ], 2),
      _withDirectives(_createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("button", {
          class: "outline-none text-red-lp-100",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moveSidebarToV2 && _ctx.moveSidebarToV2(...args)))
        }, " Kembali ke versi terbaru ")
      ], 512), [
        [_vShow, _ctx.permissionToggleVersionSidebarEnabled]
      ]),
      (_ctx.isVisibleSaldo)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", {
              class: 
          `bg-white mx-2 rounded-md border border-gray-lp-400 ${
            _ctx.isCollapse ? 'justify-center items-center' : 'py-2 px-4 xxl:py-4'
          } ${_ctx.isHideBalanceDetail ? '' : 'cursor-pointer'}`
        ,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.gotoBalance && _ctx.gotoBalance(...args)))
            }, [
              _withDirectives(_createVNode("div", {
                class: ["flex flex-row w-full text-12px mb-1", {
            'justify-center': _ctx.isCollapse,
            'justify-between': !_ctx.isCollapse
          }]
              }, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('profile.balanceAvailable')), 1),
                  (_ctx.level?.title && !_ctx.accountIsForeign)
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        _createVNode("img", {
                          src: require(`@/app/ui/assets/svg/level/${_ctx.level?.icon}.svg`),
                          class: "w-4 h-auto",
                          alt: "level"
                        }, null, 8, ["src"]),
                        _createVNode("div", {
                          class: `pl-1 text-12px font-bold text-${_ctx.level?.color}`
                        }, _toDisplayString(_ctx.level?.title), 3)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2), [
                [_vShow, !_ctx.isCollapse]
              ]),
              _createVNode("div", {
                class: ["flex flex-row w-full text-lg items-center", {
            'justify-center py-2': _ctx.isCollapse
          }]
              }, [
                _createVNode("img", {
                  src: _imports_1,
                  class: ["w-6", { 'mr-2': !_ctx.isCollapse }],
                  alt: "coin"
                }, null, 2),
                (_ctx.isLoadingBalance)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      height: "1.2rem",
                      width: "100%"
                    }))
                  : _createCommentVNode("", true),
                (
              !_ctx.isCollapse &&
                _ctx.dataProfile.account_type_detail &&
                !_ctx.isLoadingBalance
            )
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      (
                _ctx.balanceData.walletBalance > _ctx.dataProfile.limit_rule_min_balance
              )
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: 
                `${
                  _ctx.isSenderAccount ? 'text-red-lp-400' : 'text-black-lp-300'
                } text-12px xxl:text-16px font-semibold`
              
                          }, _toDisplayString(_ctx.priceView), 3))
                        : (_openBlock(), _createBlock("div", {
                            key: 1,
                            class: 
                `${
                  !_ctx.isSenderAccount ? 'text-red-lp-300' : 'text-red-lp-400'
                } text-12px xxl:text-16px font-semibold`
              
                          }, _toDisplayString(_ctx.priceView), 3))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.dataProfile.account_type_detail !== null && !_ctx.isSenderAccount)
                  ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_12, [
                      _createVNode("img", {
                        src: 
                _ctx.balanceData.walletBalance <=
                  _ctx.dataProfile.limit_rule_min_balance +
                    _ctx.dataProfile.limit_rule_limit_border &&
                _ctx.balanceData.walletBalance >= _ctx.dataProfile.limit_rule_min_balance
                  ? require('@/app/ui/assets/svg/exclamation-circle-solid-yellow.svg')
                  : require('@/app/ui/assets/svg/exclamation-circle-solid.svg')
              ,
                        class: `w-4 cursor-pointer ${_ctx.isCollapse ? 'ml-0' : 'ml-2'}`,
                        onMouseenter: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openTooltip && _ctx.openTooltip(...args))),
                        onMouseleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeTooltip && _ctx.closeTooltip(...args))),
                        alt: "warning"
                      }, null, 42, ["src"]),
                      (_ctx.isOpenTooltip && _ctx.dataProfile.account_type_detail !== null)
                        ? (_openBlock(), _createBlock(_component_Tooltip, {
                            key: 0,
                            title: 
                _ctx.balanceData.walletBalance <=
                  _ctx.dataProfile.limit_rule_min_balance +
                    _ctx.dataProfile.limit_rule_limit_border &&
                _ctx.balanceData.walletBalance >= _ctx.dataProfile.limit_rule_min_balance
                  ? _ctx.$t('Saldo Anda mendekati limit')
                  : _ctx.balanceData.walletBalance <
                    _ctx.dataProfile.limit_rule_min_balance
                  ? _ctx.$t('Saldo Anda dibawah limit')
                  : _ctx.$t('Saldo Anda mencapai limit')
              ,
                            message: _ctx.$t('Lakukan pengisian saldo sekarang juga. Pastikan saldo Anda tersedia sebelum melakukan aktivitas pengiriman.'),
                            class: "top-0",
                            style: {"width":"300px","margin-left":"40px","margin-top":"-22px"}
                          }, null, 8, ["title", "message"]))
                        : _createCommentVNode("", true)
                    ], 512)), [
                      [_vShow, 
              _ctx.isShowBalance
                ? _ctx.balanceData.walletBalance <=
                  _ctx.dataProfile.limit_rule_min_balance +
                    _ctx.dataProfile.limit_rule_limit_border
                : false
            ]
                    ])
                  : _createCommentVNode("", true)
              ], 2),
              (_ctx.isSenderAccount && !_ctx.isCollapse)
                ? (_openBlock(), _createBlock("div", _hoisted_13, " Poin: " + _toDisplayString(_ctx.displayBalancePoint), 1))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.isOcbcVisible && !_ctx.isProgressiveCommissionAvailable)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleOcbcDialog(true))),
                  class: "mt-2 mx-2 bg-red-lp-100 rounded relative cursor-pointer shadow overflow-hidden"
                }, [
                  _createVNode("div", _hoisted_14, [
                    (!_ctx.isCollapse)
                      ? (_openBlock(), _createBlock("div", _hoisted_15, [
                          _hoisted_16,
                          _hoisted_17
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isCollapse)
                      ? (_openBlock(), _createBlock("div", _hoisted_18, [
                          _hoisted_19,
                          _hoisted_20
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isCollapse)
                      ? (_openBlock(), _createBlock("div", _hoisted_21, [
                          _hoisted_22
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isOcbcVisible && _ctx.isProgressiveCommissionAvailable)
              ? (_openBlock(), _createBlock("hr", _hoisted_23))
              : _createCommentVNode("", true),
            (_ctx.isOcbcVisible && _ctx.isProgressiveCommissionAvailable)
              ? (_openBlock(), _createBlock("div", {
                  key: 2,
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goToDetailBonusKomisi && _ctx.goToDetailBonusKomisi(...args))),
                  class: "mt-2 mx-2 bg-green-lp-400 rounded relative cursor-pointer shadow overflow-hidden"
                }, [
                  _createVNode("div", {
                    class: 
            `flex flex-no-wrap ${
              _ctx.isCollapse ? 'justify-center' : 'justify-start'
            }`
          
                  }, [
                    (!_ctx.isCollapse)
                      ? (_openBlock(), _createBlock("div", _hoisted_24, [
                          _createVNode("div", _hoisted_25, " Bonus " + _toDisplayString(_ctx.currentBonus) + "% ", 1),
                          (_ctx.isNextKomisiAvaible)
                            ? (_openBlock(), _createBlock("div", _hoisted_26, [
                                _hoisted_27,
                                _createVNode("div", _hoisted_28, [
                                  _createTextVNode(_toDisplayString(_ctx.calculateDifference.toString()) + " ", 1),
                                  _hoisted_29,
                                  _createTextVNode(" Bonus " + _toDisplayString(_ctx.nextBonus.toString()) + "% ", 1)
                                ])
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_30, [
                                _hoisted_31,
                                _hoisted_32,
                                _createVNode("p", null, "komisi tertinggi sebesar " + _toDisplayString(_ctx.currentBonus) + "%.", 1),
                                _hoisted_33
                              ]))
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isCollapse)
                      ? (_openBlock(), _createBlock("div", _hoisted_34, [
                          _hoisted_35
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isCollapse)
                      ? (_openBlock(), _createBlock("div", _hoisted_36, [
                          _hoisted_37
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            _hoisted_38
          ]))
        : _createCommentVNode("", true),
      (_ctx.isVisibleCod)
        ? (_openBlock(), _createBlock("div", _hoisted_39, [
            _createVNode("div", {
              class: ["bg-white mx-2 rounded-md border border-gray-lp-400 cursor-pointer", {
          'justify-center items-center': _ctx.isCollapse,
          'p-4': !_ctx.isCollapse
        }],
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.gotoCodIncome && _ctx.gotoCodIncome(...args)))
            }, [
              _withDirectives(_createVNode("div", {
                class: ["flex flex-row w-full text-12px mb-1", {
            'justify-center': _ctx.isCollapse,
            'justify-between': !_ctx.isCollapse
          }]
              }, [
                _hoisted_40
              ], 2), [
                [_vShow, !_ctx.isCollapse]
              ]),
              _createVNode("div", {
                class: ["flex flex-row w-full text-lg items-center", {
            'justify-center py-2': _ctx.isCollapse
          }]
              }, [
                _createVNode("img", {
                  src: _imports_6,
                  class: ["w-6", { 'mr-2': !_ctx.isCollapse }],
                  alt: "coin"
                }, null, 2),
                (_ctx.isLoadingBalance)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      height: "1.2rem",
                      width: "100%"
                    }))
                  : _createCommentVNode("", true),
                (
              !_ctx.isCollapse &&
                _ctx.dataProfile.account_type_detail &&
                !_ctx.isLoadingBalance
            )
                  ? (_openBlock(), _createBlock("div", _hoisted_41, [
                      _createVNode("div", _hoisted_42, _toDisplayString(_ctx.codIncomePriceView), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2),
            _hoisted_43
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_44, [
        (_openBlock(), _createBlock("div", {
          key: _ctx.indexRoutes,
          class: "py-2 overflow-auto"
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.routes, (item, index) => {
            return (_openBlock(), _createBlock("ul", {
              key: `main-menu-${index}`,
              class: 
            `text-gray-lp-300 font-normal ${item.meta.divide &&
              'border-t border-gray-lp-400 pt-2 mt-2'}`
          ,
              id: `main-menu-${index}`
            }, [
              (
              (!item.meta || !item.meta.hidden) &&
                !_ctx.hideMenuForType(item.meta.hideFeatureFor)
            )
                ? (_openBlock(), _createBlock("li", {
                    key: 0,
                    id: `menu-${index}`,
                    class: 
              `${_ctx.currentRoute.includes(item.meta?.maskedPath || item.path) &&
                !item.meta.children &&
                'text-red-lp-100 bg-gray-lp-200 font-medium'}${item.meta
                .children &&
                _ctx.isOpen &&
                _ctx.now === index &&
                'text-red-lp-100'} cursor-pointer flex flex-col w-full sidebar-item px-4`
            
                  }, [
                    _createVNode("div", {
                      class: ["flex flex-row w-full py-2.5 xxl:py-3", {
                'justify-center': _ctx.isCollapse,
                'justify-between': !_ctx.isCollapse
              }],
                      onClick: ($event: any) => (
                item.meta.children
                  ? _ctx.openChildren(index, item.meta)
                  : _ctx.toMenu(item.path, item.meta, item.meta.children)
              )
                    }, [
                      (item.meta.icon === 'shopify')
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: "flex flex-row items-center relative",
                            onMouseover: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.hoverSpesificIcon && _ctx.hoverSpesificIcon(...args))),
                            onMouseout: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.unHoverSpesificIcon && _ctx.unHoverSpesificIcon(...args)))
                          }, [
                            _createVNode(_component_SidebarIcon, {
                              name: item.meta.icon,
                              spesific: item.meta.spesific,
                              isSpesificActive: _ctx.currentRoute.includes(item.path) && !item.meta.children,
                              isSpesificHover: _ctx.isHoverSpesificIcon,
                              class: 
                    `h-4 xxl:h-5 ${
                      _ctx.currentRoute.includes(item.path) && !item.meta.children
                        ? 'text-red-lp-100'
                        : item.meta.children && _ctx.isOpen && _ctx.now === index
                        ? 'text-red-lp-100'
                        : 'text-gray-lp-600'
                    }  ${!_ctx.isCollapse ? 'mr-2' : 'mr-0'}`
                  
                            }, null, 8, ["name", "spesific", "isSpesificActive", "isSpesificHover", "class"]),
                            _withDirectives(_createVNode("div", _hoisted_45, [
                              _createVNode(_component_Circle, { style: {"width":"10px"} })
                            ], 512), [
                              [_vShow, _ctx.isCollapse && item.count]
                            ]),
                            _withDirectives(_createVNode("span", null, _toDisplayString(_ctx.$t(item.meta.name ? item.meta.name : "")), 513), [
                              [_vShow, !_ctx.isCollapse]
                            ])
                          ], 32))
                        : (_openBlock(), _createBlock("div", _hoisted_46, [
                            _createVNode(_component_SidebarIcon, {
                              name: item.meta.icon,
                              class: 
                    `h-4 xxl:h-5 sidebar-icon ${
                      _ctx.currentRoute.includes(item.meta?.maskedPath || item.path) && !item.meta.children
                        ? 'text-red-lp-100'
                        : item.meta.children && _ctx.isOpen && _ctx.now === index
                        ? 'text-red-lp-100'
                        : 'text-gray-lp-600'
                    }  ${!_ctx.isCollapse ? 'mr-2' : 'mr-0'}`
                  
                            }, null, 8, ["name", "class"]),
                            _withDirectives(_createVNode("div", _hoisted_47, [
                              _createVNode(_component_Circle, { style: {"width":"10px"} })
                            ], 512), [
                              [_vShow, _ctx.isCollapse && item.count]
                            ]),
                            _withDirectives(_createVNode("span", null, _toDisplayString(_ctx.$t(item.meta.name ? item.meta.name : "")), 513), [
                              [_vShow, !_ctx.isCollapse]
                            ])
                          ])),
                      _withDirectives(_createVNode("div", _hoisted_48, [
                        _withDirectives(_createVNode(_component_Pill, { text: "12" }, null, 512), [
                          [_vShow, item.count]
                        ]),
                        (
                    item.meta?.showIconNotification && _ctx.showIconNotificationMenuSidebar
                  )
                          ? (_openBlock(), _createBlock(_component_Icons, {
                              key: 0,
                              name: "bell",
                              fill: "",
                              class: "w-6 text-red-lp-2000"
                            }))
                          : _createCommentVNode("", true),
                        _withDirectives(_createVNode("img", {
                          src: _imports_7,
                          class: 
                    `w-5
                    ${_ctx.isOpen && _ctx.now === index ? 'active' : 'not-active'}`
                  ,
                          alt: "right"
                        }, null, 2), [
                          [_vShow, item.meta.children]
                        ]),
                        _withDirectives(_createVNode(_component_Pill, {
                          text: _ctx.totalSTTPaidUnread.toString()
                        }, null, 8, ["text"]), [
                          [_vShow, 
                    _ctx.totalSTTPaidUnread &&
                      item.name === 'stt-paid-unpaid' &&
                      _ctx.currentRouteName !== 'stt-paid-unpaid'
                  ]
                        ]),
                        _withDirectives(_createVNode(_component_Pill, { text: _ctx.pusatResolusiPillText }, null, 8, ["text"]), [
                          [_vShow, item.name === 'pusat-resolusi-v2']
                        ]),
                        _withDirectives(_createVNode(_component_Pill, { text: "New" }, null, 512), [
                          [_vShow, item.name === 'booking-v2']
                        ])
                      ], 512), [
                        [_vShow, !_ctx.isCollapse]
                      ])
                    ], 10, ["onClick"]),
                    _withDirectives(_createVNode("div", _hoisted_49, [
                      _createVNode("div", _hoisted_50, [
                        _createVNode("div", _hoisted_51, [
                          (item.children.length)
                            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(item.children, (child) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: child.name
                                }, [
                                  _withDirectives(_createVNode("div", {
                                    onClick: ($event: any) => (
                          _ctx.toMenu(
                            item.path + '/' + child.path,
                            child.meta,
                            child
                          )
                        ),
                                    class: 
                          `${_ctx.currentRoute.includes(child.meta?.maskedPath || child.path) &&
                            'text-red-lp-100 bg-gray-lp-200 font-medium'} gap-1 py-2.5 xxl:py-3 px-2 cursor-pointer flex flex-row items-center justify-between sidebar-item`
                        
                                  }, [
                                    _createVNode("div", _hoisted_52, [
                                      _createVNode(_component_SidebarIcon, {
                                        class: 
                              `h-4 xxl:h-5 ${
                                _ctx.currentRoute.includes(child.meta?.maskedPath || child.path)
                                  ? 'text-red-lp-100||'
                                  : 'text-gray-lp-600'
                              } sidebar-icon mr-2`
                            ,
                                        name: child.meta.icon
                                      }, null, 8, ["class", "name"]),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t(child.meta.customName ? child.meta.customName : child.meta.name ? child.meta.name : "")), 1)
                                    ]),
                                    _withDirectives(_createVNode(_component_Pill, { text: "34" }, null, 512), [
                                      [_vShow, child.count]
                                    ]),
                                    _withDirectives(_createVNode(_component_Pill, { text: _ctx.bulkBookingPillText }, null, 8, ["text"]), [
                                      [_vShow, child.name === 'bulk-v2']
                                    ])
                                  ], 10, ["onClick"]), [
                                    [_vShow, 
                          _ctx.checkRolePermission(child.meta.permission) &&
                            !_ctx.hideMenuForType(child.meta.hideFeatureFor)
                        ]
                                  ])
                                ]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 512), [
                      [_vShow, _ctx.isOpen && _ctx.now === index && _ctx.isCollapse === false]
                    ]),
                    _withDirectives(_createVNode("div", {
                      class: "left-0 flex flex-row items-center absolute justify-center duration-1000 z-30",
                      style: 
                `border-left: 30px solid transparent; margin-left: ${_ctx.isOpen &&
                  _ctx.now === index &&
                  _ctx.isCollapse === true &&
                  _ctx.width + 10}px; ${_ctx.isOpen &&
                  _ctx.now === index &&
                  _ctx.isCollapse === true &&
                  `top: ${_ctx.top}px`}`
              
                    }, [
                      _createVNode("div", {
                        id: `sub-menu-${index}`,
                        class: "bg-white relative flex flex-col w-64",
                        style: {"box-shadow":"0px 0px 3px 1px #b1b1b1"}
                      }, [
                        _createVNode("div", _hoisted_53, _toDisplayString(_ctx.$t(item.meta.name ? item.meta.name : '')), 1),
                        _createVNode("div", _hoisted_54, [
                          (item.children.length)
                            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(item.children, (child) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: child.name
                                }, [
                                  _withDirectives(_createVNode("div", {
                                    class: 
                          `${
                            _ctx.currentRoute.includes(child.meta?.maskedPath || child.path)
                              ? 'text-red-lp-100'
                              : 'text-gray-lp-300'
                          } py-2.5 xxl:py-3 cursor-pointer flex flex-row items-center justify-between sidebar-item`
                        ,
                                    onClick: ($event: any) => (
                          _ctx.toMenu(
                            item.path + '/' + child.path,
                            child.meta,
                            child
                          )
                        )
                                  }, [
                                    _createVNode("div", _hoisted_55, [
                                      _createVNode(_component_SidebarIcon, {
                                        class: 
                              `h-4 xxl:h-5 ${
                                _ctx.currentRoute.includes(child.meta?.maskedPath || child.path)
                                  ? 'text-red-lp-100'
                                  : 'text-gray-lp-600'
                              } sidebar-icon mr-2`
                            ,
                                        name: child.meta.icon
                                      }, null, 8, ["class", "name"]),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t(child.meta.name ? child.meta.name : '')), 1)
                                    ]),
                                    _withDirectives(_createVNode(_component_Pill, { text: "34" }, null, 512), [
                                      [_vShow, child.count]
                                    ])
                                  ], 10, ["onClick"]), [
                                    [_vShow, 
                          _ctx.checkRolePermission(child.meta.permission) &&
                            !_ctx.hideMenuForType(child.meta.hideFeatureFor)
                        ]
                                  ])
                                ]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, ["id"])
                    ], 4), [
                      [_vShow, _ctx.isOpen && _ctx.now === index && _ctx.isCollapse === true]
                    ])
                  ], 10, ["id"]))
                : _createCommentVNode("", true)
            ], 10, ["id"]))
          }), 128))
        ])),
        (!_ctx.isSenderAccount && _ctx.flagPermissionFeedback)
          ? (_openBlock(), _createBlock(_component_MenuRating, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", {
        class: ["w-full block bg-gray-lp-700 border-t border-gray-lp-400 font-normal", {'pb-4': _ctx.isShowRunningText}]
      }, [
        _createVNode("ul", _hoisted_56, [
          (!_ctx.isSenderAccount && _ctx.showNotification)
            ? _withDirectives((_openBlock(), _createBlock("li", {
                key: 0,
                id: "menu-notification",
                class: 
            `${_ctx.currentRoute === 'notifications' && 'text-red-lp-100'} ${
              _ctx.isCollapse ? 'justify-center' : 'justify-between'
            } tooltip py-2 xxl:py-3 flex flex-row items-center sidebar-item`
          ,
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onOpenNotification && _ctx.onOpenNotification(...args)))
              }, [
                _createVNode("div", _hoisted_57, [
                  _createVNode(_component_Notification, {
                    class: 
                `h-4 xxl:h-5 sidebar-icon ${
                  _ctx.currentRoute.includes('/notifications')
                    ? 'text-red-lp-100'
                    : 'text-gray-lp-600'
                } ${!_ctx.isCollapse ? 'mr-2' : 'mr-0'}`
              
                  }, null, 8, ["class"]),
                  _withDirectives(_createVNode("div", _hoisted_58, [
                    _createVNode(_component_Circle, { style: {"width":"10px"} })
                  ], 512), [
                    [_vShow, _ctx.isCollapse]
                  ]),
                  _withDirectives(_createVNode("span", null, _toDisplayString(_ctx.$t("Notifikasi")), 513), [
                    [_vShow, !_ctx.isCollapse]
                  ])
                ]),
                _withDirectives(_createVNode(_component_Pill, {
                  text: _ctx.countUnread(_ctx.unreadData.unread || 0).toString()
                }, null, 8, ["text"]), [
                  [_vShow, 
              !_ctx.isCollapse && _ctx.countUnread(_ctx.unreadData.unread) > 0 && !_ctx.isError
            ]
                ]),
                _withDirectives(_createVNode("div", {
                  class: "left-0 bottom-0 flex flex-row items-center absolute justify-center",
                  style: `margin-left: ${_ctx.notification.width + 35}px; bottom: 30px`
                }, [
                  _createVNode("div", _hoisted_59, [
                    _createVNode("div", _hoisted_60, [
                      _createVNode("div", _hoisted_61, [
                        _createVNode("div", _hoisted_62, [
                          _createVNode("div", _hoisted_63, _toDisplayString(_ctx.$t("Notifikasi")), 1),
                          _withDirectives(_createVNode(_component_Pill, {
                            text: _ctx.countUnread(_ctx.unreadData.unread || 0).toString()
                          }, null, 8, ["text"]), [
                            [_vShow, 
                        !_ctx.isCollapse &&
                          _ctx.countUnread(_ctx.unreadData.unread) > 0 &&
                          !_ctx.isError
                      ]
                          ])
                        ]),
                        _createVNode("div", {
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.goAllNotification && _ctx.goAllNotification(...args))),
                          class: "text-red-lp-100 font-semibold text-12px cursor-pointer"
                        }, _toDisplayString(_ctx.$t("breadcrumb.seeAllMessages")), 1)
                      ]),
                      (_ctx.isLoading)
                        ? (_openBlock(), _createBlock("div", _hoisted_64, " Loading... "))
                        : (_openBlock(), _createBlock("div", _hoisted_65, [
                            (_ctx.isError)
                              ? (_openBlock(), _createBlock("div", _hoisted_66, [
                                  _createVNode(_component_ErrorMessage, {
                                    errorType: _ctx.errorCause,
                                    onTryAgain: _ctx.getUnreadList
                                  }, null, 8, ["errorType", "onTryAgain"])
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.isNotificationsExist && !_ctx.isError)
                              ? (_openBlock(), _createBlock("div", _hoisted_67, [
                                  _hoisted_68,
                                  _hoisted_69
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.isError && _ctx.isNotificationsExist)
                              ? (_openBlock(), _createBlock("div", _hoisted_70, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allData, (e, i) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: i.toString()
                                    }, [
                                      _createVNode("div", _hoisted_71, _toDisplayString(i), 1),
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(e, (item, index) => {
                                        return (_openBlock(), _createBlock("div", {
                                          key: index.toString()
                                        }, [
                                          _createVNode("a", {
                                            class: 
                            `${!item.read && 'bg-gray-lp-700'} ${index ===
                              e.length - 1 &&
                              'border-b border-gray-lp-400'} cursor-pointer px-6 py-2 xxl:py-3 flex flex-row items-start`
                          ,
                                            onClick: ($event: any) => (_ctx.goDetail(item.id))
                                          }, [
                                            _createVNode("div", _hoisted_72, [
                                              _createVNode("div", {
                                                class: 
                                `${
                                  _ctx.initialNameNotification(item.createdBy).color
                                } ${!_ctx.isCollapse &&
                                  'mr-2'} w-6 h-6 font-semibold text-10px items-center tracking-wider flex flex-col justify-center text-white rounded-full`
                              
                                              }, _toDisplayString(_ctx.initialNameNotification(item.createdBy).initial), 3)
                                            ]),
                                            _createVNode("div", _hoisted_73, [
                                              _createVNode("div", _hoisted_74, [
                                                _createVNode("div", _hoisted_75, [
                                                  _createVNode("span", _hoisted_76, _toDisplayString(item.createdBy), 1),
                                                  _createVNode("span", null, _toDisplayString(item.createdBy.length + item.title.length > 90
                                    ? `${_ctx.firstCapitalize(
                                        item.createdBy +
                                          _ctx.$t("sharedNewsPrefix") +
                                          item.title
                                      ).substr(
                                        item.createdBy.length,
                                        90 - item.createdBy.length
                                      )}...`
                                    : ` ${_ctx.$t("sharedNewsPrefix")} ${_ctx.firstCapitalize(
                                        item.title
                                      )}`), 1)
                                                ]),
                                                _createVNode("div", _hoisted_77, _toDisplayString(_ctx.dateToTime(item.createdAt)), 1)
                                              ]),
                                              (item.bannerImage && _ctx.isOpenNotification)
                                                ? (_openBlock(), _createBlock("img", {
                                                    key: 0,
                                                    src: item.bannerImage,
                                                    class: "pt-4 object-cover h-20",
                                                    alt: ""
                                                  }, null, 8, ["src"]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ], 10, ["onClick"])
                                        ]))
                                      }), 128))
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createVNode("div", {
                      class: "arrow-left absolute z-10",
                      style: `bottom: ${_ctx.isLargeScreen ? '118' : '100'}px`
                    }, null, 4)
                  ])
                ], 4), [
                  [_vShow, _ctx.isOpenNotification]
                ])
              ], 2)), [
                [_directive_click_outside, _ctx.onCloseNotification]
              ])
            : _createCommentVNode("", true),
          _createVNode("li", {
            class: 
            `${
              _ctx.isCollapse ? 'justify-center' : 'justify-between'
            } tooltip py-2 xxl:py-3 cursor-pointer flex flex-row items-center sidebar-item`
          ,
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
          }, [
            _createVNode("div", _hoisted_78, [
              _createVNode(_component_Logout, {
                class: 
                `h-4 xxl:h-5 sidebar-icon text-gray-lp-600 ${
                  !_ctx.isCollapse ? 'mr-2' : 'mr-0'
                }`
              
              }, null, 8, ["class"]),
              _withDirectives(_createVNode("span", null, _toDisplayString(_ctx.$t('profile.logout')), 513), [
                [_vShow, !_ctx.isCollapse]
              ])
            ])
          ], 2)
        ]),
        _createVNode("button", {
          class: "hover:text-red-lp-200 cursor-pointer border-t border-gray-lp-400 focus:outline-none w-full",
          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.toAccount && _ctx.toAccount(...args)))
        }, [
          _createVNode("div", {
            class: [`${_ctx.currentRoute === '/account' && 'bg-gray-lp-200'}`, "p-4 flex flex-row items-center justify-between profile-box"]
          }, [
            _createVNode("div", _hoisted_79, [
              _createVNode("div", _hoisted_80, [
                _createVNode("div", {
                  class: 
                  `${_ctx.initialName.color} ${!_ctx.isCollapse &&
                    'mr-2'} w-10 h-10 font-medium text-lg tracking-wider flex flex-col items-center justify-center text-white rounded-full relative`
                
                }, [
                  (_ctx.isCustomerService)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: 
                    `rounded-full border border-white absolute bottom-0 right-0 ${
                      _ctx.statusAccount.status ? 'bg-green-lp-400' : 'bg-red-lp-100'
                    }`
                  ,
                        style: {"width":"10px","height":"10px"}
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createVNode("span", null, _toDisplayString(_ctx.initialName.initial), 1)
                ], 2)
              ]),
              _withDirectives(_createVNode("div", _hoisted_81, [
                _createVNode("div", {
                  class: 
                  `font-medium text-12px xxl:text-14px ${
                    _ctx.currentRoute === '/account'
                      ? 'text-red-lp-100'
                      : 'text-black-lp-200'
                  }`
                
                }, _toDisplayString(_ctx.ellipsisString(_ctx.dataProfile.name, 17)), 3),
                (_ctx.isSenderAccount)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: 
                  `font-normal text-11px ${
                    _ctx.currentRoute === '/account'
                      ? 'text-red-lp-100'
                      : 'text-gray-lp-500'
                  }`
                
                    }, _toDisplayString(_ctx.normalizePhoneNumber(_ctx.dataProfile.phone_number)), 3))
                  : _createCommentVNode("", true),
                _createVNode("div", {
                  class: 
                  `font-normal text-11px ${
                    _ctx.currentRoute === '/account'
                      ? 'text-red-lp-100'
                      : 'text-gray-lp-500'
                  }`
                
                }, _toDisplayString(_ctx.ellipsisString(_ctx.dataProfile.email, 20)), 3),
                (_ctx.isCustomerService)
                  ? (_openBlock(), _createBlock(_component_Toggle, {
                      key: 1,
                      "onUpdate:modelValue": [
                        _ctx.onClickToggleStatus,
                        _cache[14] || (_cache[14] = ($event: any) => (_ctx.statusAccount.status = $event))
                      ],
                      modelValue: _ctx.statusAccount.status,
                      textActive: "Aktif",
                      textInactive: "Tidak Aktif",
                      styleActive: "bg-green-lp-400",
                      class: "-ml-1 mt-1",
                      onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["onUpdate:modelValue", "modelValue"]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, !_ctx.isCollapse]
              ])
            ])
          ], 2)
        ])
      ], 2)
    ], 2), [
      [_directive_click_outside, _ctx.clickOutside]
    ]),
    (_ctx.isOpenModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onClose: _ctx.onSubmit,
          onSubmit: _ctx.onClose,
          textSuccess: _ctx.$t('Tidak'),
          textCancel: _ctx.$t('Ya'),
          title: _ctx.$t('profile.logoutConfirmTitle'),
          message: 
      _ctx.$t(
        'Sebelum Anda keluar pastikan kembali tidak ada proses aktivitas yang berjalan atau semua aktivitas sudah selesai.'
      )
    ,
          image: "logout-image"
        }, null, 8, ["onClose", "onSubmit", "textSuccess", "textCancel", "title", "message"]))
      : _createCommentVNode("", true),
    (_ctx.isErrorLogout)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 1,
          onCancel: _ctx.handleCloseError,
          errorType: _ctx.errorCauseLogout,
          modal: "",
          onTryAgain: _ctx.onSubmit
        }, null, 8, ["onCancel", "errorType", "onTryAgain"]))
      : _createCommentVNode("", true),
    _createVNode(_component_OcbcPopupModal, {
      modelValue: _ctx.ocbcDialogModelValue,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.ocbcDialogModelValue = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_ModalFeedbackReview)
  ], 64))
}